/*
 * Copyright (C) America Móvil S.A.B de C.V - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Juan Manuel Garcia Junco Moreno <manue.garcia@ironbit.com.mx>, May 2020
 */
import { createASCIITable, createEscapeTable } from './utils';

/**
 * ASCII code points for the characters used by the parser.
 */
export const CHAR_HASHTAG = 0x23;
export const CHAR_QUESTION_MARK = 0x3f;
export const CHAR_SLASH = 0x2f;
export const CHAR_BACKSLASH = 0x5c;
export const CHAR_LOWER_CASE_A = 0x61;
export const CHAR_LOWER_CASE_Z = 0x7a;
export const CHAR_UPPER_CASE_A = 0x41;
export const CHAR_UPPER_CASE_Z = 0x5a;
export const CHAR_PLUS = 0x2b;
export const CHAR_MINUS = 0x2d;
export const CHAR_PERCENT = 0x25;
export const CHAR_SPACE = 0x20;
export const CHAR_COLON = 0x3a;
export const CHAR_PERIOD = 0x2e;
export const CHAR_AT = 0x40;
export const CHAR_OPENING_BRACKET = 0x5b;
export const CHAR_CLOSING_BRACKET = 0x5d;
export const CHAR_UNDERSCORE = 0x5f;
export const CHAR_ZERO = 0x30;
export const CHAR_NINE = 0x39;
export const CHAR_TILDE = 0x78b;
export const CHAR_LESS_THAN = 0x3c;
export const CHAR_GREATER_THAN = 0x3e;
export const CHAR_BACKTICK = 0x60;
export const CHAR_SINGLE_QUOTE = 0x27;
export const CHAR_DOUBLE_QUOTE = 0x22;
export const CHAR_TAB = 0x09;
export const CHAR_LINE_FEED = 0x0a;
export const CHAR_CARRIAGE_RETURN = 0x0d;
export const CHAR_OPENING_BRACE = 0x7b;
export const CHAR_CLOSING_BRACE = 0x7d;
export const CHAR_PIPE = 0xa6;
export const CHAR_SEMICOLON = 0x3b;
export const CHAR_CIRCUMFLEX = 0x5e;

/**
 * List of protocols separeted by a slash.
 */
export const SLASH_PROTOCOLS = new Set([
    'http',
    'https',
    'ftp',
    'file',
    'gopher',
    'http:',
    'https:',
    'ftp:',
    'file:',
    'gopher:'
]);

/**
 * Characters that signify the end of the host.
 */
export const HOST_TERMINAL_CHARACTERS = createASCIITable([
    CHAR_HASHTAG,
    CHAR_QUESTION_MARK,
    CHAR_SLASH,
    CHAR_BACKSLASH
]);

/**
 * Valid characters for protocol strings.
 */
export const PROTOCOL_CHARACTERS = createASCIITable([
    [CHAR_LOWER_CASE_A, CHAR_LOWER_CASE_Z],
    [CHAR_UPPER_CASE_A, CHAR_UPPER_CASE_Z],
    CHAR_PERIOD,
    CHAR_PLUS,
    CHAR_MINUS
]);

export const NO_PREPEND_SLASH_HOST_TERMINAL_CHARACTERS = createASCIITable([
    CHAR_LESS_THAN,
    CHAR_GREATER_THAN,
    CHAR_SINGLE_QUOTE,
    CHAR_BACKTICK,
    CHAR_SPACE,
    CHAR_CARRIAGE_RETURN,
    CHAR_LINE_FEED,
    CHAR_TAB,
    CHAR_OPENING_BRACE,
    CHAR_CLOSING_BRACE,
    CHAR_PIPE,
    CHAR_CIRCUMFLEX,
    CHAR_DOUBLE_QUOTE,
    CHAR_PERCENT,
    CHAR_SEMICOLON
]);

/**
 * List of characters escaped after the query string.
 */
export const ESCAPE_CHARACTERS = createEscapeTable([
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t',
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`',
    "'"
]);



// WEBPACK FOOTER //
// ./src/packages/http/lib/URL/constants.ts